/* Dansk katalog for locale-vat-purchases-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'vat.term': 'Momsperiode',
  'vat.termHelp': 'En momsperiode er en periode, du indberetter moms for. De fleste indberetter hver anden måned - 6 perioder om året. For hver periode summeres udgående og indgående moms, og forskellen betales til eller fås tilbage fra staten.',
  'vat.termShort': 'periode',
  'vat.deadline': 'FRIST',
  'vat.amountHelp': 'Moms at betale betyder, at du skylder staten, fordi udgående moms var større end indgående moms. Moms til gode betyder, at du får penge tilbage, fordi du har betalt mere moms på køb, end du opkrævede på salg.',
  'vat.openReturn': 'Åbn angivelse',
  'vat.sortHelp': 'Perioderne er sorteret efter status: Kræver handling skal indsendes nu, Kommende er fremtidige perioder, og Tidligere er allerede indsendt eller betalt.',
  'vat.noTerms': 'Ingen momsperioder endnu',
  'vat.incompleteBasisTitle': 'Momsgrundlaget er ufuldstændigt',
  'vat.incompleteBasisText': 'MVA-meldingen vises ikke som komplet, fordi journaldækningen ikke er dokumenteret. Dokumentberegninger kan stadig bruges diagnostisk, men ikke som komplet regnskabsgrundlag.',
  'vat.needsAction': 'Kræver handling',
  'vat.upcoming': 'Kommende',
  'vat.earlier': 'Tidligere',
  'vat.toPay': 'Moms at betale',
  'vat.toPayHelp': 'Samlet udestående moms, hvor udgående moms er større end indgående moms.',
  'vat.paidIn': 'Indbetalt',
  'vat.paidInHelp': 'Momsbetalinger, du har registreret mod perioder i Plumme.',
  'vat.refunded': 'Tilbagebetalt',
  'vat.refundedHelp': 'Momstilbagebetalinger, du har registreret mod perioder i Plumme.',
  'vat.perTerm': 'Pr. periode',
  'vat.returnStatus': 'Status for MVA-melding',
  'vat.period': 'Periode',
  'vat.due': 'Frist',
  'vat.calculated': 'Beregnet afregning',
  'vat.settlement': 'Afregning',
  'vat.cancelPayment': 'Annuller betaling',
  'vat.date': 'Dato',
  'vat.amount': 'Beløb',
  'vat.reference': 'Reference',
  'vat.referencePh': 'F.eks. netbank, OCR',
  'vat.payments': 'Betalinger',
  'vat.paymentsHelp': 'Oversigt over betalinger registreret mod denne momsperiode.',
  'vat.noPayments': 'Ingen betalinger registreret',
  'vat.fromAccount': 'Fra konto',
  'vat.edit': 'Redigér',
  'vat.cancel': 'Annuller',
  'vat.cancelPaymentTitle': 'Annuller betaling?',
  'vat.cancelPaymentConfirm': 'Ja, annuller betaling',
  'vat.backToTerms': 'Tilbage til perioder',
  'vat.importedBasisTitle': 'Importeret fra andet regnskabssystem',
  'vat.importedBasisHelp': 'Tallene er importeret som grundlag. Du kan oprette, indsende og om nødvendigt annullere MVA-meldingen med det almindelige forløb.',
  'vat.outputVat': 'Udgående moms',
  'vat.outputVatHelp': 'Moms, du har opkrævet på salget i perioden.',
  'vat.inputVat': 'Indgående moms',
  'vat.inputVatHelp': 'Fradragsberettiget moms, du har betalt på køb i perioden.',
  'vat.netVat': 'Nettomoms',
  'vat.netHelp': 'Udgående minus indgående moms. Positivt beløb betales, negativt beløb er til gode.',
  'vat.checkStatus': 'Tjek status',
  'vat.checkStatusHelp': 'Vis Plummes gemte status for MVA-meldingen. Automatisk status fra Altinn eller Skatteetaten er endnu ikke tilknyttet i denne Plumme-visning.',
  'vat.seePayment': 'Se betaling',
  'vat.seePaymentHelp': 'Se de betalinger, der er registreret mod denne momsperiode — dato, konto, beløb og reference.',
  'vat.codeOverview': 'Kodeoversigt til indsendelse',
  'vat.codeOverviewHelp': 'MVA-meldingen bygges op af standardiserede momskoder fra Skatteetaten. Hver kode samler en bestemt slags salg eller køb. Grundlaget er beløbet uden moms. Ved omvendt betalingspligt vises både udgående og indgående moms, selv når nettoen er 0. Tryk på en kode for at se, hvad der hører hjemme der.',
  'vat.codeTapHint': 'Tryk på en kode for at se, hvad der hører hjemme der.',
  'vat.code': 'Kode',
  'vat.description': 'Beskrivelse',
  'vat.basis': 'Grundlag',
  'vat.rate': 'Sats',
  'vat.vat': 'Moms',
  'vat.calculatedFrom': 'Beregnet ud fra det, du har registreret i appen',
  'vat.delete': 'Slet',
  'vat.annulCustoms': 'Annuller',
  'vat.annulled': 'Annulleret',
  'vat.showAnnulledCustoms': 'Vis annullerede',
  'vat.showActiveCustoms': 'Vis aktive',
  'vat.customsAnnulled': 'Tolddeklaration annulleret',
  'vat.customsAnnulFailed': 'Tolddeklarationen kunne ikke annulleres.',
  'vat.registerCustoms': 'Registrér tolddeklaration',
  'vat.customsHelp': 'Indtast en tolddeklaration for varer, du har importeret fra udlandet. Plumme beregner importmoms ud fra den statistiske værdi og lægger den på den rigtige kode i angivelsen.',
  'vat.flowHelp': 'Kontrollér tallene fra de bogførte bilag. Plumme kan ikke sende MVA-meldingen: du indsender den i Skatteetatens tjeneste og markerer derefter perioden som indsendt uden for Plumme her. Så kan du registrere betalingen. Indsendt-status kan fjernes igen, hvis den blev sat ved en fejl.',
  'vat.filing.statusFiled': 'Indsendt uden for Plumme',
  'vat.filing.statusFiledPaid': 'Indsendt uden for Plumme og betalt',
  'vat.filing.statusNotFiled': 'Ikke markeret som indsendt',
  'vat.filing.reviewFigures': 'Kontrollér tallene',
  'vat.filing.reviewedToast': 'Tallene er kontrolleret. Indsend MVA-meldingen hos Skatteetaten.',
  'vat.filing.markOutside': 'Markér som indsendt uden for Plumme',
  'vat.filing.clearStatus': 'Fjern indsendt-status',
  'vat.filing.dialogTitle': 'Indsend MVA-meldingen hos Skatteetaten',
  'vat.filing.cannotSend': 'Plumme kan ikke sende eller signere MVA-meldingen. Du indsender den selv hos Skatteetaten og markerer perioden som indsendt her bagefter.',
  'vat.filing.step1': 'Åbn MVA-meldingen i Skatteetatens tjeneste, og indtast tallene for denne periode fra Plumme.',
  'vat.filing.step2': 'Indsend og signér angivelsen der, og gem kvitteringen.',
  'vat.filing.step3': 'Markér perioden som indsendt uden for Plumme her. Så kan du registrere betalingen, og perioden tæller som indsendt i årsafslutningen.',
  'vat.filing.termNotEnded': 'Perioden er ikke slut endnu. MVA-meldingen kan først indsendes, når perioden er slut.',
  'vat.filing.filedDate': 'Indsendelsesdato',
  'vat.filing.reference': 'Reference (valgfrit)',
  'vat.filing.referencePh': 'For eksempel referencen på kvitteringen fra Skatteetaten',
  'vat.filing.comment': 'Kommentar (valgfrit)',
  'vat.filing.lockNote': 'Når perioden er markeret som indsendt, låses bilagene i perioden. Ændringer skal så laves som en rettelse.',
  'vat.filing.clearText': 'Perioden står så som ikke indsendt i Plumme, og bilagene i perioden låses op igen. Ændringen logges med hvem og hvornår. Status hos Skatteetaten ændres ikke.',
  'vat.filing.clearReason': 'Begrundelse (valgfrit)',
  'vat.filing.markedToast': 'Perioden er markeret som indsendt uden for Plumme',
  'vat.filing.clearedToast': 'Indsendt-status er fjernet',
  'vat.filing.failed': 'Momsstatus kunne ikke opdateres.',
  'vat.filing.payAfterFiled': 'Tilgængelig, når MVA-meldingen er indsendt hos Skatteetaten og markeret som indsendt her.',
  'vat.filing.markedOn': 'Markeret i Plumme',
  'vat.filing.referenceLabel': 'Reference',
  'vat.filing.commentLabel': 'Kommentar',
  'vat.filing.statusNote': 'Plumme henter ikke status fra Skatteetaten. Statussen her er det, der er markeret i Plumme.',
  'vat.addComment': 'Tilføj kommentar',
  'vat.customs': 'Tolddeklaration',
  'vat.correctCustoms': 'Ret tolddeklaration',
  'vat.saveCustoms': 'Gem tolddeklaration',
  'vat.fetchFromAltinn': 'Hent fra Altinn',
  'vat.fetchFromAltinnHelp': 'Udfyld reference og toldgrundlag automatisk fra indsendte angivelser.',
  'vat.declarationRef': 'Angivelsesreference',
  'vat.declarationRefPh': 'Reference fra tolden',
  'vat.statisticalValue': 'Statistisk værdi',
  'vat.vatCode': 'Momskode',
  'vat.attachments': 'Vedhæftninger / importspor',
  'vat.uploadAttachment': 'Upload vedhæftning',
  'vat.attachmentHelp': 'Valgfrit, men anbefales af hensyn til revisionssporet og senere opfølgning på importen.',
  'vat.customsBasis': 'Toldgrundlag',
  'vat.calculatedVat': 'Beregnet moms',
  'vat.deductible': 'Fradragsret',
  'vat.settlementDate': 'Afregningsdato',
  'vat.settlementType': 'Type afregning',
  'vat.useDueDate': 'Forfaldsdato',
  'vat.useDueDateHelp': 'Sæt afregningsdatoen til forfaldsdatoen for MVA-meldingen',
  'vat.addSurcharges': 'Tilføj renter/gebyr',
  'vat.surcharges': 'Renter og gebyr',
  'vat.removeSurcharges': 'Fjern',
  'vat.lateInterest': 'Morarente',
  'vat.lateInterestHelp': 'Bogføres som renteudgift på 8150',
  'vat.penaltyFee': 'Gebyr eller tvangsbøde',
  'vat.penaltyFeeHelp': 'Bogføres på 7799 og er ikke fradragsberettiget',
  'vat.surchargeTotal': 'Trækkes fra kontoen',
  'vat.surchargeNote': 'Renter og gebyrer er ikke moms. De udgiftsføres og trækkes fra kontoen, men ændrer ikke momsafregningen for perioden.',
  'vat.kid': 'KID',
  'vat.payTitle': 'Betal moms til Skatteetaten',
  'vat.payHelp': 'Kontonummer og KID kommer fra Skatteetaten, når meldingen er behandlet. Betaling direkte fra banken er ikke forbundet endnu, så betalingen registreres i Plumme indtil videre.',
  'vat.awaitingAuthority': 'Kommer fra Skatteetaten',
  'vat.pay': 'Betal',
  'vat.kidHelp': 'KID fra MVA-meldingen',
  'vat.authorityAccount': 'Skatteetatens kontonummer',
  'vat.authorityAccountHelp': 'Skatteetatens kontonummer',
  'vat.notRegistered': 'Virksomheden er ikke angivet som momsregistreret',
  'vat.view': 'Visning',
  'vat.viewHelp': 'Skift mellem »Perioder« — et kort pr. momsperiode med status og frist — og »Oversigt«, der opsummerer, hvad du skylder, har betalt og har til gode på tværs af perioderne.',
  'vat.viewTerms': 'Perioder',
  'vat.viewOverview': 'Oversigt',
  'vat.filing.notFiled': 'Ikke indsendt',
  'vat.filing.upcomingStatus': 'Kommende',
  'vat.filing.importedArchive': 'Importeret arkiv',
  'vat.vatReceivable': 'Moms til gode',
  'vat.vatToPay': 'Moms til betaling',
  'vat.noVat': 'Ingen moms',
  'vat.receivableShort': 'Til gode',
  'vat.remainingToPay': 'Mangler at blive betalt',
  'vat.termLabel': '{n}. periode {year}',
  'vat.noTermsHelp': 'Når virksomheden er momsregistreret, viser Plumme perioder, frister og beregnet moms her.',
  'vat.youOwe': 'Du skylder',
  'vat.youAreOwed': 'Du har til gode',
  'vat.noVatToSettle': 'Ingen moms at afregne',
  'vat.refund': 'Tilbagebetaling',
  'vat.paymentNoun': 'Betaling',
  'vat.settlementNoun': 'Afregning',
  'vat.acctBankDeposit': 'Bankindestående',
  'vat.acctTaxDeductionAccount': 'Skattetrækskonto',
  'vat.acctCash': 'Kontanter',
  'vat.accountFallback': '{code} Konto',
  'vat.settlementFullyRegistered': 'Fuldt registreret',
  'vat.settlementPartiallyRegistered': 'Delvist registreret',
  'vat.settlementNotRegistered': 'Ikke registreret',
  'vat.editRefund': 'Rediger tilbagebetaling',
  'vat.editPayment': 'Rediger betaling',
  'vat.receivedOn': 'Modtaget på',
  'vat.paidFrom': 'Betalt fra',
  'vat.noPaymentsHelp': 'Når du registrerer en betaling eller tilbagebetaling for perioden, vises den her.',
  'vat.addRefund': 'Tilføj tilbagebetaling',
  'vat.addPayment': 'Tilføj betaling',
  'vat.cancelPaymentConfirmPrefix': 'Vil du annullere {kind} på',
  'vat.cancelPaymentConfirmDate': ' registreret {date}',
  'vat.cancelPaymentConfirmSuffix': '? Beløbet fjernes fra momsperioden og kan ikke gendannes.',
  'vat.overpaid': 'Betalt for meget',
  'vat.overrefunded': 'Fået for meget tilbage',
  'vat.remainingToReceive': 'Mangler at blive modtaget',
  'vat.registerSettlement': 'Registrer afregning',
  'vat.registerPayment': 'Registrer betaling',
  'vat.registerRefund': 'Registrer tilbagebetaling',
  'vat.inYourFavor': 'i din favør',
  'vat.toTaxAuthority': 'til Skatteetaten',
  'vat.receivedBack': 'Fået tilbage',
  'vat.archiveCannotSettle': 'Importeret historik kan ikke afregnes som en ny Plumme-periode.',
  'vat.noVatToSettleForTerm': 'Perioden har ingen moms at afregne.',
  'vat.sourceImported': 'Importeret',
  'vat.sourceManual': 'Registreret manuelt',
  'vat.registerVatRefund': 'Registrer momstilbagebetaling',
  'vat.registerVatPayment': 'Registrer momsbetaling',
  'vat.saveRefund': 'Gem tilbagebetaling',
  'vat.savePayment': 'Gem betaling',
  'vat.remainingHint': 'Resterende {amount}',
  'vat.notRegisteredHelp': 'Når virksomheden angives som momsregistreret i indstillingerne, viser Plumme momsperioder, kodeoversigt og afregning her.',
  'vat.reviewReadyToast': 'MVA-meldingen er klargjort til kontrol',
  'vat.customsAltinnNotConnected': 'Altinn-import af toldangivelser er ikke forbundet endnu.',
  'vat.selectAttachmentToUpload': 'Vælg en vedhæftning at uploade',
  'vat.customsDefaultDescription': 'Toldangivelse',
  'vat.customsDateTermHint': 'Datoen skal ligge inden for {period}.',
  'vat.customs81': '25 % med fradragsret',
  'vat.customs82': '25 % uden fradragsret',
  'vat.customs83': '15 % med fradragsret',
  'vat.customs84': '15 % uden fradragsret',
  'vat.customs85': '0 % indførsel',
  'vat.customsSaved': 'Toldangivelse gemt',
  'vat.customsSaveFailed': 'Kunne ikke gemme toldangivelsen.',
  'vat.customsDeleted': 'Toldangivelse slettet',
  'vat.customsDeleteFailed': 'Kunne ikke slette toldangivelsen.',
  'vat.refundSaved': 'Tilbagebetaling gemt',
  'vat.paymentSaved': 'Betaling gemt',
  'vat.paymentSaveFailed': 'Kunne ikke gemme betalingen.',
  'vat.refundCancelled': 'Tilbagebetaling annulleret',
  'vat.paymentCancelled': 'Betaling annulleret',
  'vat.paymentCancelFailed': 'Kunne ikke annullere betalingen.',
  'vat.supplierSearch': 'Søg efter eller tilføj leverandør...',
  'vat.supplierClose': 'Luk leverandørvalg',
  'vat.supplierNone': 'Ingen leverandører fundet.',
  'vat.supplierNew': 'Ny leverandør',
  'vat.supplierName': 'Navn',
  'vat.supplierOrg': 'Org.nr.',
  'vat.supplierEmail': 'E-mail',
  'vat.supplierPhone': 'Telefon',
  'vat.customsPostingExplanation': 'Brug tallene fra toldangivelsen. Moms uden fradragsret skal bogføres på den rigtige omkostnings- eller aktivkonto.',
  'vat.nonDeductibleAccount': 'Konto til moms uden fradragsret',
  'vat.nonDeductibleAccountHelp': 'Vælg den samme omkostnings- eller aktivkonto, som anskaffelsen vedrører. Konto skal angives før bogføring.',
  'voucherList.titleHelp': 'Et bilag er dokumentationen bag en bogføring: faktura, kvittering, andet salg, toldangivelse eller fri postering. Her ser du de bilag, der er hentet fra backend for det valgte regnskabsår.',
  'voucherList.backToTrialBalance': 'Tilbage til saldobalancen',
  'voucherList.backToIncomeStatement': 'Tilbage til resultatopgørelsen',
  'voucherList.accountBadge': 'Konto {number} · {name}',
  'voucherList.vatCodeBadge': 'Momskode {code}',
  'voucherList.viewOptions': 'Visningsvalg',
  'voucherList.noneForVatCode': 'Ingen bilag fundet for momskode {code} i den valgte periode.',
  'voucherList.noneForAccount': 'Ingen bilag bogført på {number} {name} i {year}.',
  'voucherList.noneMatchSearch': 'Ingen bilag matcher søgningen.',
  'voucherList.noneInView': 'Ingen bilag matcher visningen.',
  'voucherList.ledgerLinesMissing': 'Bilagene mangler bogføringslinjer fra backend.',
  'voucherList.debit': 'Debet',
  'voucherList.credit': 'Kredit',
  'voucherList.colVoucher': 'Bilag',
  'voucherList.colNumber': 'Bilagsnr.',
  'voucherList.colDate': 'Dato',
  'voucherList.inlineVat': 'Moms',
  'voucherList.kindInvoice': 'Faktura',
  'voucherList.kindSupplier': 'Leverandør',
  'voucherList.kindCreditNote': 'Kreditnota',
  'voucherList.kindManual': 'Manuelt bilag',
  'voucherList.kindPurchase': 'Køb',
  'voucherList.kindOtherSale': 'Andet salg',
  'voucherList.kindMileage': 'Kørebog',
  'voucherList.kindCustoms': 'Toldangivelse',
  'voucherList.kindCustomsCorrection': 'Periodekorrektion af toldangivelse',
  'voucherList.kindBankPosting': 'Bankpostering',
  'voucherList.kindPayment': 'Betaling',
  'voucherList.kindPayroll': 'Løn',
  'voucherList.kindPayrollPayment': 'Lønudbetaling',
  'voucherList.kindReversal': 'Tilbageførsel',
  'voucherList.kindPublicFees': 'Offentlige afgifter',
  'voucherList.kindAssetDisposal': 'Afhændelse af driftsmiddel',
  'voucherList.kindYearEnd': 'Årsafslutning',
  'voucherList.kindQuote': 'Tilbud',
  'voucherList.kindOrderConfirmation': 'Ordrebekræftelse',
  'voucherList.filterSales': 'Salg',
  'voucherList.filterSupplierInvoice': 'Leverandørfaktura',
  'voucherList.filterFreePosting': 'Fri postering',
  'voucherList.missingAttachment': 'Mangler vedhæftning',
  'voucherList.hasAttachment': 'Har vedhæftning',
  'voucherList.unpaid': 'Ubetalt',
  'voucherList.showAnnulled': 'Vis annullerede',
  'voucherList.hidePayments': 'Skjul betalinger',
  'voucherList.includeAnnulled': 'Vis også annullerede',
  'vat.amountOnly': 'Kun moms',
  'voucherList.onlyAnnulled': 'Vis kun annullerede',
  'voucherList.paid': 'Betalt',
  'voucherList.partiallyPaid': 'Delvist betalt',
  'voucherList.annulled': 'Annulleret',
  'voucherList.attachmentLost': 'Bilag mistet',
  'voucherList.openInvoiceList': 'Se i fakturalisten',
  'voucherList.editSale': 'Rediger salg',
  'voucherList.openInBank': 'Åbn i bank',
  'voucherList.editPosting': 'Rediger postering',
  'voucherList.correctPosting': 'Korrigér bilag',
  'voucherList.editMileage': 'Rediger kørebog',
  'voucherList.openInVat': 'Åbn i moms',
  'voucherList.edit': 'Rediger',
  'voucherList.purchaseNotFound': 'Kunne ikke finde det køb, der skal redigeres. Prøv at opdatere siden, og åbn bilaget igen.',
  'voucherList.saleNotFound': 'Kunne ikke finde det salg, der skal redigeres. Prøv at opdatere siden, og åbn bilaget igen.',
  'inboxStatus.alreadyBooked': 'Allerede bogført?',
  'inboxStatus.booked': 'Bogført',
  'inboxStatus.inTrash': 'I papirkurven',
  'inboxStatus.readyToBook': 'Klar til bogføring',
  'inboxStatus.needsReview': 'Kræver kontrol',
  'inboxStatus.analysisFailed': 'Analyse mislykkedes',
  'inboxStatus.analyzing': 'Analyseres',
  'inboxStatus.awaitingAnalysis': 'Venter på analyse',
  'inboxStatus.show': 'Vis',
  'inboxStatus.hide': 'Skjul',
  'inboxStatus.dropReceipts': 'Slip bilagene her',
  'inboxStatus.dropReceiptsHint': 'SuperPlumma aflæser det, vi kan',
  'inboxStatus.dropDocuments': 'Slip dokumenterne her',
  'inboxStatus.dropDocumentsHint': 'Lægges i Dokumentation',
  'inboxStatus.bookWithSuperPlumma': 'Bogfør med SuperPlumma',
  'inboxStatus.saving': 'Gemmer...',
  'purchaseFlow.stepReceipt': 'Bilag',
  'purchaseFlow.stepDetails': 'Detaljer',
  'purchaseFlow.stepLines': 'Linjer',
  'purchaseFlow.stepPreview': 'Forhåndsvisning',
  'purchaseFlow.typeRegular': 'Betalt køb',
  'purchaseFlow.typeInvoice': 'Leverandørfaktura',
  'purchaseFlow.typeDrafts': 'Kladder',
  'purchaseFlow.receivedReading': 'Bilag modtaget - SuperPlumma læser det nu',
  'purchaseFlow.receivedReadingMany': '{count} bilag modtaget - SuperPlumma læser dem nu',
  'purchaseFlow.prefilled': 'SuperPlumma udfyldte det, der kunne læses fra bilaget. Kontrollér, før du bogfører.',
  'purchaseFlow.amountReview': 'Beløb og moms kunne ikke udfyldes sikkert. Kontrollér bilaget, og angiv nettobeløb og korrekt momsbehandling pr. linje, før du bogfører.',
  'purchaseFlow.analysisFailed': 'Bilaget blev uploadet, men analysen mislykkedes.',
  'purchaseFlow.inboxResolveFailed': 'Posteringen er gemt, men bilaget blev ikke fjernet fra indbakken. Markér det som bogført der.',
  'purchaseFlow.receiptFallbackName': 'Bilag',
});
